import IComponent from "components/commons/IComponent";
import DocumentTreeView from "../DocumentTreeView";
class ESFS extends IComponent {
  constructor(props) {
    super(props);
    this.state = {
      TreeView: [],
      oldFeaturesTreeView: [],
    };
  }
  async componentDidMount() {
    let cachedData = this.props.cachedData;
    if (cachedData) {
      this.setState(cachedData);
      this.props.isShowTabCallback(true);
      return;
    }
    if (this.props.text !== "") {
      let data = {
        Key: this.props.text,
      };
      var queryTexturalResults,
        oldFeaturesTreeView = [],
        queryOldFeatureCheckResult,
        oldFeatureCheck,
        oldTreeCaption;
      try {
        queryTexturalResults = await this.fetchQueryByPOST(
          this.$config.ManMadeSlopeInfoList.ESFSUrl,
          data
        );
        queryOldFeatureCheckResult = await this.fetchQueryByPOST(
          this.$config.ManMadeSlopeInfoList.OldFeaturesUrl,
          data
        );
        oldFeatureCheck = await queryOldFeatureCheckResult.json();
        if (oldFeatureCheck && oldFeatureCheck.length > 0) {
          oldTreeCaption = `${oldFeatureCheck?.[0]?.OLD_FEATREF} (Old Feature)`;
          oldFeaturesTreeView = await this.fetchQueryByPOST(
            this.$config.ManMadeSlopeInfoList.ESFSUrl,
            {
              Key: oldFeatureCheck[0].OLD_FEATREF,
            }
          );
          oldFeaturesTreeView = await oldFeaturesTreeView.json();
        }
      } catch {
        this.props.isShowTabCallback(false);
        return;
      }
      var treeViewResult = await queryTexturalResults.json();
      if (treeViewResult) {
        this.props.onCachePanelData(this.props.title, {
          TreeView: treeViewResult,
          oldFeaturesTreeView,
          oldTreeCaption,
        });
        if (!treeViewResult.length) this.props.isShowTabCallback(false);
        else this.props.isShowTabCallback(true);
      }

      this.setState({
        TreeView: treeViewResult,
        oldFeaturesTreeView,
        oldTreeCaption,
      });
    }
  }
  componentWillUnmount() {}
  render() {
    let { TreeView, oldFeaturesTreeView, oldTreeCaption } = this.state;
    return (
      <div>
        <div className="SubPanelTitle">ESFS</div>
        {/* {TreeView.map((i) => i.children)
          .flat()
          .some((i) => i?.ATTACH !== null) && (
          <div style={{ position: "absolute", right: 20 }}>
            * Attachment available
          </div>
        )} */}
        <div
          style={{
            float: "right",
            position: "relative",
            right: "10px",
            top: "10px",
          }}
        >
          * Attachment available
        </div>
        <DocumentTreeView tree={TreeView} showDialog={this.props.showDialog} />
        {oldFeaturesTreeView.length > 0 && (
          <DocumentTreeView
            tree={oldFeaturesTreeView}
            caption={oldTreeCaption}
            showDialog={this.props.showDialog}
          />
        )}
      </div>
    );
  }
}

export default ESFS;
